const escapeHtml = (value) =>
  String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

const fmtMoney = (value) => new Intl.NumberFormat("vi-VN").format(Math.round(Number(value) || 0));

const splitDate = (text = "") => {
  const [day = "", month = "", year = ""] = String(text).split("/");
  return { day, month, year };
};

const renderDateByParts = (text = "") => {
  const { day, month, year } = splitDate(text);
  return `Ngày ${escapeHtml(day || "...")} tháng ${escapeHtml(month || "...")} năm ${escapeHtml(year || "....")}`;
};

export const getPrintTemplate = ({ header, committeeMembers }) => {
  const members = (committeeMembers || []).filter((member) => member.fullName || member.position || member.representative || member.role);
  const committeeChair = members[0] || {};

  const committeeRowsHtml = members
    .map(
      (member) => `
      <div class="line">Ông/Bà: ${escapeHtml(member.fullName)} Chức vụ ${escapeHtml(member.position)} Đại diện ${escapeHtml(member.representative)} ${escapeHtml(member.role)}</div>
    `
    )
    .join("");

  return `
  <html>
    <head>
      <meta charset="utf-8" />
      <title>Biên bản thanh lý TSCĐ</title>
      <style>
        @media print { @page { margin: 10mm 10mm 14mm; size: portrait; } }
        body { font-family: "Times New Roman", Times, serif; color: #000; font-size: 15px; line-height: 1.45; }
        .header { display: flex; justify-content: space-between; align-items: flex-start; }
        .right { text-align: center; }
        .title { text-align: center; margin-top: 12px; font-weight: 700; font-size: 30px; text-transform: uppercase; }
        .subtitle { text-align: center; margin-top: 4px; font-style: italic; }
        .line { margin-top: 4px; }
        .section-title { font-weight: 700; margin-top: 8px; }
        .sign-row-2 { display: flex; justify-content: space-between; margin-top: 24px; }
        .sign-col-2 { width: 44%; text-align: center; }
        .sign-date-line { min-height: 24px; }
        .sign-row-1 { display: flex; justify-content: flex-end; margin-top: 18px; }
        .sign-col-1 { width: 44%; text-align: center; }
      </style>
    </head>
    <body>
      <div class="header">
        <div>
          <div><b>Đơn vị:</b> ${escapeHtml(header.unit)}</div>
          <div><b>Bộ phận:</b> ${escapeHtml(header.department)}</div>
        </div>
        <div class="right">
          <div><b>Mẫu số 02 - TSCĐ</b></div>
          <div><i>(Kèm theo Thông tư số 99/2025/TT-BTC</i></div>
          <div><i>ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</i></div>
        </div>
      </div>

      <div class="title">BIÊN BẢN THANH LÝ TSCĐ</div>
      <div class="subtitle">${renderDateByParts(header.documentDate)}</div>

      <div class="header" style="margin-top: 6px;">
        <div></div>
        <div>
          <div>Số: ${escapeHtml(header.documentNumber)}</div>
          <div>Nợ: ${escapeHtml(header.debitAccount)}</div>
          <div>Có: ${escapeHtml(header.creditAccount)}</div>
        </div>
      </div>

      <div class="line">Căn cứ Quyết định số: ${escapeHtml(header.decisionNumber)} ngày ${escapeHtml(header.decisionDate)} về việc ${escapeHtml(header.liquidationReason)}</div>

      <div class="section-title">I. Ban thanh lý TSCĐ gồm:</div>
      ${committeeRowsHtml}

      <div class="section-title">II. Tiến hành thanh lý TSCĐ:</div>
      <div class="line">- Tên, ký mã hiệu, quy cách (cấp hạng) TSCĐ: ${escapeHtml(header.assetNameSpecification)}</div>
      <div class="line">- Số hiệu TSCĐ/Mã TSCĐ: ${escapeHtml(header.assetCode)}</div>
      <div class="line">- Năm sản xuất: ${escapeHtml(header.manufactureYear)}</div>
      <div class="line">- Năm đưa vào sử dụng: ${escapeHtml(header.useYear)}    Số thẻ TSCĐ: ${escapeHtml(header.assetCardNumber)}</div>
      <div class="line">- Nguyên giá TSCĐ: ${fmtMoney(header.originalCost)}</div>
      <div class="line">- Giá trị hao mòn đã trích đến thời điểm thanh lý: ${fmtMoney(header.accumulatedDepreciation)}</div>
      <div class="line">- Giá trị còn lại của TSCĐ: ${fmtMoney(header.remainingValue)}</div>

      <div class="section-title">III. Kết luận của Ban thanh lý TSCĐ:</div>
      <div class="line">${escapeHtml(header.committeeConclusion)}</div>

      <div class="sign-row-1">
        <div class="sign-col-1">
          <div>${renderDateByParts(header.committeeDate)}</div>
          <div><b>Trưởng Ban thanh lý</b></div>
          <div><i>(Ký, họ tên)</i></div>
          <div style="height: 40px;"></div>
          <div><b>${escapeHtml(committeeChair.fullName || "")}</b></div>
        </div>
      </div>

      <div class="section-title">IV. Kết quả thanh lý TSCĐ:</div>
      <div class="line">- Chi phí thanh lý TSCĐ: ${fmtMoney(header.liquidationCost)} (${escapeHtml(header.liquidationCostText)})</div>
      <div class="line">- Giá trị thu hồi: ${fmtMoney(header.recoveryValue)} (${escapeHtml(header.recoveryValueText)})</div>
      <div class="line">- Đã ghi giảm sổ TSCĐ ngày ${escapeHtml(header.derecognitionDate)}</div>

      <div class="sign-row-2">
        <div class="sign-col-2">
          <div class="sign-date-line"></div>
          <div><b>Giám đốc</b></div>
          <div><i>(Ký, họ tên, đóng dấu)</i></div>
        </div>
        <div class="sign-col-2">
          <div class="sign-date-line">${renderDateByParts(header.closingDate)}</div>
          <div><b>Kế toán trưởng</b></div>
          <div><i>(Ký, họ tên)</i></div>
        </div>
      </div>

      <script>window.onload=function(){window.print();}</script>
    </body>
  </html>
  `;
};
